(function(){
  /* the theme replaces the buy button on every size change, so always read it fresh */
  function btn(){return document.querySelector('.product-form__submit')}
  function selectedId(){var b=btn();var f=b&&b.closest('form');var i=f&&f.querySelector('input[name="id"],select[name="id"]');return i?i.value:null}
  function init(){
    if(!btn()) return;
    var data=document.getElementById('szr-stock-data');
    var map={};try{map=data?JSON.parse(data.textContent):{}}catch(e){}
    var line=document.getElementById('szr-stock');
    var bar=null;
    function money(){var p=document.querySelector('.price-item--sale, .price-item--regular, .price-item');return p?p.textContent.trim():''}
    function soldOut(){var b=btn();return !!b&&/sold out/i.test(b.textContent)}
    function refresh(){
      var v=map[selectedId()];
      if(line){
        if(v&&v.m==='shopify'&&v.q>0&&v.q<=5){line.textContent='Only '+v.q+' left in '+v.t;line.hidden=false}else{line.hidden=true}
      }
      if(bar){
        bar.querySelector('b').textContent=(document.querySelector('h1')||{}).textContent||'';
        bar.querySelector('span').textContent=(v?v.t+' · ':'')+money();
        var so=soldOut();
        bar.querySelector('button').disabled=so;
        bar.querySelector('button').textContent=so?'Sold out':'Add to cart';
      }
    }
    function place(){
      if(!bar) return; var b=btn(); if(!b) return;
      bar.classList.toggle('is-on',b.getBoundingClientRect().bottom<0);
    }
    if(window.matchMedia('(max-width:989px)').matches){
      bar=document.createElement('div');bar.className='szr-sticky';
      bar.innerHTML='<div class="szr-sticky__meta"><b></b><span></span></div><button type="button">Add to cart</button>';
      document.body.appendChild(bar);
      bar.querySelector('button').addEventListener('click',function(){var b=btn();if(b)b.click()});
      window.addEventListener('scroll',place,{passive:true});
    }
    function later(){setTimeout(refresh,80);setTimeout(refresh,700);setTimeout(refresh,1600)}
    document.addEventListener('change',later);
    document.addEventListener('click',later);
    refresh();place();
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init)}else{init()}
})();
